import { lazy } from "react";

// project imports
import Loadable from "../component/Loadable";
import MinimalLayout from "../layout/MinimalLayout";
import GuestGuard from "./../utils/route-guard/GuestGuard";
import config from "./../config";
import ContactUsPage from "ContactUsComponent/contactusPage";
import ScreenStatic from "ContactUsComponent/ScreenStatic";
// login option 3 routing
const Login = Loadable(lazy(() => import("../pages/auth/Login")));
const AdminHandoff = Loadable(lazy(() => import("../pages/auth/AdminHandoff")));
// const TwoStepAuth = Loadable(lazy(() => import("../pages/auth/TwoStepAuth")));
const Signup = Loadable(lazy(() => import("../pages/Signup")));
const NoMatch = Loadable(lazy(() => import("../pages/errors/NoMatch")));
const ForgotPassword = Loadable(lazy(() => import("../pages/auth/ForgotPassword")));
const ResetPassword = Loadable(lazy(() => import("../pages/auth/ResetPassword")));
const TermsAndConditionHyperLink = Loadable(lazy(() => import("../pages/Signup/hyperlink")));
// const Booking = Loadable(lazy(() => import("../pages/Booking")));

// import { useSelector } from "react-redux";
// const { isLoggedIn } = useSelector((state) => state.auth);

const AuthenticationRoutes = {
  path: config.basePath + "/",
  element: <MinimalLayout />,
  children: [
    {
      path: config.basePath + "/login/handoff",
      element: <AdminHandoff />,
    },
    {
      path: config.basePath + "/login",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: config.basePath + "/signup",
      element: (
        <GuestGuard>
          <Signup />
        </GuestGuard>
      ),
    },
    {
      path: config.basePath + "/forgotpassowrd",
      element: (
        <GuestGuard>
          <ForgotPassword />
        </GuestGuard>
      ),
    },
    {
      path: config.basePath + "/reset-password/:token",
      element: <ResetPassword />,
    },
    {
      path: config.basePath + "/termsandconditions",
      element: (
        <GuestGuard>
          <TermsAndConditionHyperLink />
        </GuestGuard>
      ),
    },
    {
      path: config.basePath + "/contact-us",
      element: <ContactUsPage />,
    },
    {
      path: config.basePath + "/request-account-deletion",
      element: <ScreenStatic />,
    },
    { path: "*", element: <NoMatch /> },
  ],
};

export default AuthenticationRoutes;
